<div>
  <gamification-header (onGrabMovement)="grabMovement()"></gamification-header>
</div>

<div
  class="px-3 py-3"
  style="background-color: #f0f0f0; display: flex; grid-gap: 15px; flex-direction: column"
>
  <div class="grid-gap-15" style="display: flex; flex-direction: row; flex-wrap: wrap">
    <div
      style="flex-grow: 1; flex-basis: 300px; display: flex; flex-direction: column"
      class="grid-gap-15"
    >
      <div>
        <gamification-profile></gamification-profile>
      </div>
      <div style="height: 100%">
        <gamification-badges (onGrabMovement)="grabMovement()"></gamification-badges>
      </div>
    </div>

    <div style="flex-grow: 1; flex-basis: 500px">
      <gamification-metrics></gamification-metrics>
    </div>
  </div>
</div>
